var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupplierIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 39,
    viewBox: "0 0 41 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.125 36.8333C6.8939 31.7753 13.3685 28.6667 20.5 28.6667C27.6315 28.6667 34.1061 31.7753 38.875 36.8333M29.6875 11.3125C29.6875 16.3866 25.5741 20.5 20.5 20.5C15.4259 20.5 11.3125 16.3866 11.3125 11.3125C11.3125 6.23838 15.4259 2.125 20.5 2.125C25.5741 2.125 29.6875 6.23838 29.6875 11.3125Z",
    stroke: "#00AEEF",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupplierIcon);
export default __webpack_public_path__ + "static/media/supplierIcon.9def1f036a4d7cbbb0d6e283579c388b.svg";
export { ForwardRef as ReactComponent };